module.exports = __webpack_public_path__ + "static/media/call.d46c47b3.svg";